import { Actor, Engine, Vector, Color, CollisionType } from "excalibur";
import { Virus } from "../Virus";
import { ProjectileCollision } from "../../systems/CollisionGroups";
import { Resources } from "../../resources";
import { createPackedAnimation } from "../../utils/AtlasLoader";

export class NeutrophilNet extends Actor {
    private duration: number = 4000;
    private damage: number = 3; // Low damage but high utility
    private slowFactor: number = 0.5; // 50% slow
    private tickRate: number = 100;
    private tickTimer: number = 0;
    private radius: number = 80;
    private onKill: (virus: Virus) => void;

    constructor(x: number, y: number, onKill: (virus: Virus) => void) {
        super({
            pos: new Vector(x, y),
            radius: 80,
            color: Color.Transparent,
            collisionType: CollisionType.Passive,
            collisionGroup: ProjectileCollision,
        });
        this.onKill = onKill;
    }

    override onInitialize(engine: Engine): void {
        // Create animation
        const anim = createPackedAnimation(
            Resources.NeutrophilNetImage,
            Resources.NeutrophilNetJson,
            12
        );

        // Scale to match radius (approx)
        const scale = (this.radius * 2.5) / anim.width;
        anim.scale = new Vector(scale, scale);
        anim.opacity = 0.7; // Semi-transparent

        this.graphics.use(anim);

        // Fade out at end
        engine.clock.schedule(() => {
            this.actions.fade(0, 200).die();
        }, this.duration - 200);
    }

    override onPreUpdate(engine: Engine, delta: number): void {
        this.tickTimer += delta;
        if (this.tickTimer >= this.tickRate) {
            this.tickTimer = 0;
            this.applyEffects(engine);
        }
    }

    private applyEffects(engine: Engine): void {
        const enemies = engine.currentScene.actors.filter(a => a instanceof Virus && a.isPoolActive()) as Virus[];

        for (const enemy of enemies) {
            if (this.pos.distance(enemy.pos) <= this.radius + enemy.collider.bounds.width / 2) {
                // Apply slow
                enemy.applySlow(this.slowFactor);

                // Apply damage
                const killed = enemy.takeDamage(this.damage);
                if (killed) {
                    this.onKill(enemy);
                }
            }
        }
    }
}
